<template>
  <div v-if="isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">home</span>
      <span class="text">{{ $t('sidebar.home') }}</span>
    </router-link>
  </div>
  <div v-if="isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/tasks"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">assignment</span>
      <span class="text">{{ $t('sidebar.tasks') }}</span>
    </router-link>
  </div>
  <div v-if="isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/historytasks"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">assignment_turned_in</span>
      <span class="text">{{ $t('sidebar.historytasks') }}</span>
    </router-link>
  </div>
  <div v-if="isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/documents"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">description</span>
      <span class="text">{{ $t('sidebar.documents') }}</span>
    </router-link>
  </div>
  <div class="flex" />
  <div v-if="!isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/login"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">login</span>
      <span class="text">{{ $t('sidebar.login') }}</span>
    </router-link>
  </div>
  <div v-if="isAuthenticated"
       class="menu"
  >
    <router-link class="button"
                 to="/account"
                 @click="hideSideBar()"
    >
      <span class="material-icons-round">account_circle</span>
      <span class="text">{{ $t('sidebar.account') }}</span>
    </router-link>
  </div>
</template>

<script setup>
import { computed} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const isAuthenticated = computed(() => store.state.sidebar.isAuthenticated)
//const is_expanded = computed(() => store.state.sidebar.isExpanded)

function hideSideBar(){
        if(window.innerWidth < 768)
            store.commit('sidebar/setIsExpanded', false);
    
}
</script>

<style lang="scss" scoped>

        .menu{
             @media(max-width:768px) {
            display: none;
  
            display: block;
            height: 38px;
            justify-content: center;
            display: flex;
            font-size: 16px;
            .button {
            width: 100%;
            display: flex;
            align-items: center;
            text-decoration: none;
            padding: 0.4rem 1rem;
            transition: 0.2s ease-out;
            opacity: 0.75;
            
            .material-icons-round {
                font-size: 1.6rem;
                color: var(--icons);
                transition: 0.2s ease-out;
            }

            .text {
                color: var(--text);
                transition: 0.2s ease-out;
                line-height: 0px;
            }
            .textButton {
                font-size: 1rem;
                color: var(--text);
                transition: 0.2s ease-out;
            }

            &:hover,
            &.router-link-exact-active {
                background-color: var(--sidebarDarkNew);
                opacity: 1;
            }

        }
              }
        }
    
aside {
     @media(max-width:768px) {
            display: none;
    }
    display: flex;
    flex-direction: column;
    width: calc(2rem + 32px);
    overflow: hidden;
    min-height: 100vh;
    padding: 1rem 1rem 0rem 1rem;
    left:0px;
    background-color: var(--sidebarNew);
    color: var(--light);

    z-index: 99;
    transition: 0.2s ease-out;

    .flex {
        flex: 1 1 0;
    }
    .versionText{
        margin-left: 4px;
        font-size: 11px;
    }
    .logo {
        margin-bottom: 1rem;color: var(--light);
        display: flex;
        height: 55px;
        img {
            max-width: 2rem;
            max-height: 55px;
            transition: 0.2s ease-out;
        }
        .logotext{
            opacity: 0;
            padding-left: 10px;
            padding-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-weight: bold;
        }
    }

    
    .menu-toggle-wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0rem;

        position: relative;
        top: 0;
        transition: 0.2s ease-out;

        .menu-toggle {
            transition: 0.2s ease-out;

            .material-icons-round {
                font-size: 2rem;
                color: var(--icons);
            }
            
           
        }
    }

    h3,
    .button .text {
        opacity: 0;
        transition: 0.3s ease-out;
    }
    .textButton {
        opacity: 0;
        transition: 0.3s ease-out;
    }

    .menu {
        background-color: var(--sidebarNew);
        margin: 0 -1rem;
        z-index: 1;
        .button {
            width: 100%;
            display: flex;
            align-items: center;
            text-decoration: none;
            padding: 0.4rem 1rem;
            transition: 0.2s ease-out;
            opacity: 0.75;
            
            .material-icons-round {
                font-size: 2rem;
                color: var(--icons);
                transition: 0.2s ease-out;
            }
            .material-icons-round {
                font-size: 2rem;
                color: var(--icons);
                transition: 0.2s ease-out;
            }

            .text {
                color: var(--text);
                transition: 0.2s ease-out;
                line-height: 0px;
            }
            .textButton {
                font-size: 1rem;
                color: var(--text);
                transition: 0.2s ease-out;
            }

            &:hover,
            &.router-link-exact-active {
                background-color: var(--sidebarDarkNew);
                opacity: 1;
            }

        }
    }

    
    

    &.is-expanded {
        width: var(--sidebar-width);
        
        transition: 0.2s ease-out;
        .menu-toggle-wrap {
            
            .menu-toggle {
                transform: rotate(-180deg);
            }
        }

        h3,
        .button .text {
            opacity: 1;
        }

        .textButton {
            opacity: 1;
        }

        .button {
            .material-icons-round {
                margin-right: 1rem;
            }
        }

        .logo {
            margin-bottom: 1rem;

            img {
                transition: 0.2s ease-out;
            }
            .logotext{
                transition: 0.2s ease-out;
                opacity: 1;
            }
        }
        
    }
    
    &.is-hidden{

        left:0px;
        transition: 0.4s ease-out;

        @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:-250px;
            display: none;
        }
    }

    @media(max-width:768px) {
            transition: 0.4s ease-out;
            position: fixed;
            z-index: 99;
            left:0px;
        }
    

}


</style>
